import './../../css/mk-brand.css';

import {useState, useEffect} from "react";
import femaleChef from "../../media/Litepaper-F img1.png";
import maleChef from "../../media/Litepaper-M img1.png";


function WhitepaperPanel() {
    useEffect(() => {}, );
    return (
        <div id="papers-whitepaper-panel" className="container">
            <div className="flex flex-col items-center justify-center">
                <div className="flex flex-col items-center mt-4">
                    <h1 className="text-brand font-extrabold text-4xl text-center justify-center mb-2 ">Papers</h1>
                    <h2 className="p-1 text-white font-bold text-md md:text-xl lg:w-1/2 text-center">metaKitchen is a P2E culinary blockchain experience that will leave your taste buds tingling. Click on White Paper to find out more.</h2>
                    <br />
                </div>
                <div className="flex items-center justify-center">
                    <img className="w-1/3" src={femaleChef}/>
                    <div className="flex flex-col w-1/4">
                        <a href="https://metakitchen.gitbook.io/metakitchen-wp/wb1pN4vYLKsa8w4IX5qL/"
                           className="cursor-pointer text-white text-center font-bold md:text-2xl bg-gray-500 rounded-full hover:bg-brand transition ease-in-out delay-150"
                        >White Paper</a>
                        <a href="https://metakitchen.gitbook.io/metakitchen-wp/wb1pN4vYLKsa8w4IX5qL/the-menu/game-mechanics"
                            className="cursor-pointer text-white text-center font-bold text-sm md:text-2xl bg-gray-500 rounded-full hover:bg-brand transition ease-in-out delay-150 mt-2 mb-2">Game Mechanics</a>
                    </div>
                    <img className="w-1/3 mb-3 " src={maleChef}/>

                </div>
            </div>
        </div>
    );
}

export default WhitepaperPanel;